import React from 'react';
import { MotionConfig } from 'framer-motion';
import { LanguageProvider } from './contexts/LanguageContext';
import { Home } from './pages/Home';
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="3k9b3fyol9i05">
      <MotionConfig reducedMotion="user" data-id="element-1" data-mp="3k9ui96ixzq9y">
        <Home data-id="element-2" data-mp="3k7i5d7s1k63r" />
      </MotionConfig>
    </LanguageProvider>;
}